import { render, staticRenderFns } from "./SelectorPreview.vue?vue&type=template&id=0e3d5286"
import script from "./SelectorPreview.vue?vue&type=script&lang=js"
export * from "./SelectorPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e3d5286')) {
      api.createRecord('0e3d5286', component.options)
    } else {
      api.reload('0e3d5286', component.options)
    }
    module.hot.accept("./SelectorPreview.vue?vue&type=template&id=0e3d5286", function () {
      api.rerender('0e3d5286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/SelectorPreview.vue"
export default component.exports